// extracted by mini-css-extract-plugin
export default {"auth-tabs__list":"auth-tabs__list___mmQjg8Gg","auth-tabs__content":"auth-tabs__content___NKFWNsdT"};